/**
 * SLOTHY SLEEVES — theme.js
 * Version: 260421(2311)  ·  April 21, 2026 — 23:11 ET
 * shop.slothysleeves.com
 *
 * Handles:
 *  1. Mobile nav toggle
 *  2. "We'll Be Back" banner — reads from Airtable via Cloudflare Worker
 *  3. Checkout blocker — disables Add to Cart when BannerActive is true
 *  4. Cart item count in header
 */

const WORKER_URL = 'https://slothysleeves-api.sales-4c5.workers.dev';

// ── MOBILE NAV ────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const toggle  = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', mobileNav.classList.contains('open'));
    });
  }

  // ── WBB BANNER + CHECKOUT BLOCKER ──────────────────────────────────────
  fetchSiteSettings();
});

let wbbTarget = null;

function pad(n) { return String(n).padStart(2, '0'); }

function timeDiff(target) {
  const diff = new Date(target) - Date.now();
  if (diff <= 0) return null;
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor((diff % 86400000) / 3600000),
    m: Math.floor((diff % 3600000) / 60000),
    s: Math.floor((diff % 60000) / 1000)
  };
}

function tickWBB() {
  if (!wbbTarget) return;
  const t = timeDiff(wbbTarget);
  const el = document.getElementById('wbb-shopify-countdown');
  if (!el) return;
  if (t) {
    el.classList.remove('complete');
    el.innerHTML =
      `<div class="wbb-shopify-tile"><div class="wbb-shopify-tile-num">${pad(t.d)}</div><div class="wbb-shopify-tile-label">Days</div></div>` +
      `<div class="wbb-shopify-tile"><div class="wbb-shopify-tile-num">${pad(t.h)}</div><div class="wbb-shopify-tile-label">Hours</div></div>` +
      `<div class="wbb-shopify-tile"><div class="wbb-shopify-tile-num">${pad(t.m)}</div><div class="wbb-shopify-tile-label">Min</div></div>` +
      `<div class="wbb-shopify-tile"><div class="wbb-shopify-tile-num">${pad(t.s)}</div><div class="wbb-shopify-tile-label">Sec</div></div>`;
  } else {
    el.classList.add('complete');
    el.textContent = "We're back! Refresh the page";
  }
}

async function fetchSiteSettings() {
  try {
    const res  = await fetch(WORKER_URL);
    const data = await res.json();
    const s    = data.settings || {};

    // Airtable stores booleans as uppercase strings ("TRUE") or real booleans.
    // Normalize aggressively: accept true, "true", "TRUE", "yes", "YES", 1, "1".
    const raw = s.BannerActive;
    const norm = String(raw == null ? '' : raw).trim().toLowerCase();
    const active = raw === true || raw === 1 || norm === 'true' || norm === 'yes' || norm === '1';

    if (active) {
      const banner = document.getElementById('wbb-shopify-banner');
      const msgEl  = document.getElementById('wbb-shopify-message');
      const cdEl   = document.getElementById('wbb-shopify-countdown');

      if (banner) banner.classList.add('active');
      document.body.classList.add('banner-visible');

      const messageText = s.BannerMessage || "We'll Be Back Soon — Catching Some Z's with the Sloths";
      if (msgEl) {
        msgEl.textContent = messageText;
      }

      // Parse return date
      if (s.BannerReturnDate) {
        wbbTarget = new Date(s.BannerReturnDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$1-$2'));
        if (isNaN(wbbTarget)) wbbTarget = new Date(s.BannerReturnDate);
        if (isNaN(wbbTarget)) wbbTarget = null;
      }

      if (wbbTarget) {
        tickWBB();
        setInterval(tickWBB, 1000);
      } else {
        // No valid return date — hide countdown, keep the message
        if (cdEl) cdEl.style.display = 'none';
      }

      // Checkout blocker — disable all ATC buttons and forms
      disableCheckout();
    }
  } catch (err) {
    console.warn('Slothy theme: Could not load site settings', err);
  }
}

function disableCheckout() {
  // Disable all Add to Cart buttons
  const selectors = [
    '.product-form__submit',
    '[name="add"]',
    '.shopify-payment-button__button',
    '.quick-add-modal__submit',
    'button[type="submit"].product-form__submit'
  ];
  selectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(btn => {
      btn.disabled = true;
      btn.textContent = "We're Away Right Now";
    });
  });

  // Show "store closed" notice on product pages
  const form = document.querySelector('form[action="/cart/add"]');
  if (form) {
    const notice = document.createElement('p');
    notice.style.cssText = 'color:#cc0000;font-size:0.875rem;font-weight:600;margin-top:12px;font-family:var(--F-display,serif);letter-spacing:0.04em;';
    notice.textContent = 'Online ordering is paused. Visit slothysleeves.com for our return date.';
    form.appendChild(notice);
  }
}
